import $ from 'jquery';
import { getState } from '~src/state';

// textFontSize viene chiamata a ogni selezione di una textbox: il listener va
// registrato una volta sola per canvas, altrimenti si accumula per tutta la sessione.
const canvasesWithScalingListener = new WeakSet();

const onTextScaling = (event) => {
  const activeObject = getState('activeObject');

  if (!activeObject || activeObject.type !== 'textbox') {
    return;
  }

  const transform = event['transform'];
  const target = transform['target'];
  if (target) {
    const fontSize = (target.fontSize * target.scaleX) / 10;
    $('#editor-font-size-input').val(fontSize.toFixed(0));
  }
};

export function textFontSize() {
  const text = getState('activeObject');

  if (!text) {
    return;
  }

  if (canvasesWithScalingListener.has(window.canvas)) {
    return;
  }

  canvasesWithScalingListener.add(window.canvas);
  window.canvas.on('object:scaling', onTextScaling);
}
